import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import Services from "@/components/Services";
import Industries from "@/components/Industries";
import Process from "@/components/Process";
import Portfolio from "@/components/Portfolio";
import Solutions from "@/components/Solutions";
import About from "@/components/About";
import GlobalPresence from "@/components/GlobalPresence";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function HomePage() {
  return (
    <div className="App" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Services />
        <Industries />
        <Process />
        <Portfolio />
        <Solutions />
        <About />
        <GlobalPresence />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
